import React from "react";
import EN from "../../locales/en";
import TextField from "./partials/TextField";

const YourMeterDetails = ({ isMpanRequired, isMprnRequired }) => (
  <div className="mt-8 border-t border-[#afb6b9]">
    <h2 className="text-[30px] font-bold text-primary mt-6">
      {EN.switch.your_meter_details.title}
    </h2>
    <div className="space-y-4">
      {isMprnRequired && (
        <>
          <h3 className="text-[22px] font-bold mt-6">
            {EN.switch.your_meter_details.gas_meter_number_section_title}
          </h3>
          <p>{EN.switch.your_meter_details.mprn_1}</p>
          <p>{EN.switch.your_meter_details.mprn_2}</p>
          <p>{EN.switch.your_meter_details.mprn_3}</p>
          <TextField
            key="meterInfo.mprn"
            name="meterInfo.mprn"
            label={EN.switch.your_meter_details.mprn}
            placeholder={EN.switch.your_meter_details.mprn_placeholder}
          />
        </>
      )}
      {isMpanRequired && (
        <>
          <h3 className="text-[22px] font-bold mt-6">
            {
              EN.switch.your_meter_details
                .electricity_meter_number_section_title
            }
          </h3>
          <p>{EN.switch.your_meter_details.mpan_1}</p>
          <TextField
            key="meterInfo.mpan"
            name="meterInfo.mpan"
            label={EN.switch.your_meter_details.mpan}
            placeholder={EN.switch.your_meter_details.mpan_placeholder}
          />
        </>
      )}
    </div>
  </div>
);

export default YourMeterDetails;
